/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import ReactTooltip from "react-tooltip";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import queryString from "query-string";
import BigCalendar, { Views } from "react-big-calendar";
import { cloneDeep as _cloneDeep } from "lodash";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import { Link, matchPath } from "react-router-dom";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import moment from "moment";
import momentTimezone from "moment-timezone";
import AppointmentHeader from "../AppointmentHeader.js";
import {
  getAppointments,
  checkRescheduleTime,
  rescheduleAppointment,
  sendNotification,
  printAppointment,
} from "../../../Actions/Appointment/appointmentAction.js";
import {
  checkIfPermissionAllowed,
  displayName,
  capitalizeFirstLetter,
} from "../../../Utils";
import CalendarEvent from "./CalendarEvent/CalendarEvent.js";
import { tSales } from "../../../i18n/useAppTranslation.js";
import { APPOINTMENT_ROUTES } from "../../../consts/routes.js";
import { EventWrapper } from "./EventWrapper/EventWrapper.js";
import { uiNotification } from "../../../services/UINotificationService.js";
import { pipe } from "../../../utilities/fp.js";
import classes from "./styles/Calendar.module.scss";
import {
  CALENDAR_STEP_OPTIONS,
  CalendarStepSelect,
} from "./components/CalendarStepSelect/CalendarStepSelect.js";
import { history } from "../../../history.js";
import {
  apiDateFormat,
  isAdditionalProviderAppointment,
  makeTitle,
  prepareEvents,
  showSelectedWeek,
  startEndDateOfWeek,
  viewDateFormat,
} from "./utilities";
import { CalendarWrapper } from "./CalendarWrapper";
import { EVENT_TYPES } from "../../../store/event/consts";
import { withGetBookingUrlsQuery } from "../../../api/queries/useGetBookingUrlsQuery.js";
import { ModalAppointmentDetails } from "./widgets/ModalAppointmentDetails";
import { PageOverlayLoader } from "../../../shared/PageOverlayLoader/PageOverlayLoader.js";
import { ModalRescheduleConfirm } from "./components/ModalRescheduleConfirm";
import { ModalPrint } from "./components/ModalPrint";
import { ModalRescheduleFee } from "./components/ModalRescheduleFee";
import { ModalRescheduleNotification } from "./components/ModalRescheduleNotification";

const localizer = BigCalendar.momentLocalizer(moment);
const DragAndDropCalendar = withDragAndDrop(BigCalendar);

const isViewDetailsApptModal = () =>
  window.location.search.includes("view_details");

class NewCalendar extends Component {
  constructor(props) {
    super(props);

    const languageData = JSON.parse(localStorage.getItem("languageData")) || {
      global: {},
      appointments: {},
    };

    const timeFormat = localStorage.getItem("timeFormat");

    let user = JSON.parse(localStorage.getItem("userData"));
    let view = Views.DAY;

    if (this.props.match.params.view) {
      view = this.props.match.params.view;
    }

    let calendarFilter = JSON.parse(localStorage.getItem("calendarFilter"));

    let showSelectedDate, selectedDate;

    if (this.props.match.params.date) {
      showSelectedDate =
        view === Views.DAY || view === "verticals"
          ? showSelectedWeek(moment(this.props.match.params.date).toDate())
          : viewDateFormat(moment(this.props.match.params.date).toDate());
      selectedDate = moment(this.props.match.params.date).toDate();
    } else if (calendarFilter) {
      showSelectedDate =
        calendarFilter.calendarView === Views.WEEK
          ? showSelectedWeek(calendarFilter.searchPickerDate)
          : viewDateFormat(calendarFilter.searchPickerDate);
      selectedDate = moment(calendarFilter.searchPickerDate).toDate();
    } else {
      showSelectedDate = moment().format("LL");
      selectedDate = moment().toDate();
    }

    this.state = {
      timeFormat,
      showSelectedDate,
      selectedDate,
      providers: [],
      tmpProviders: [],
      clinics: [],
      calendarView: view,
      showLoader: !!this.props.match.params.view,
      selectedClinic: "",
      showAppointmentDetails: false,
      editAppointmentId: 0,
      notificationSent: false,
      globalLang: languageData.global,
      appointmentLang: languageData.appointments,
      forceChanged: false,
      showNotifyPop: false,
      showModal: false,
      showPrintModal: false,
      notification_type: "emailAndSms",
      showRescheduleConfirmModal: false,
      success_msg: "",
      patient_name: "",
      clinic_timezone: "",
      providerName: "",
      disableCalendar: false,
      verticalsList: [],
      verticalsEnabled: user.user.vertical_view,
      calendarStep: CALENDAR_STEP_OPTIONS[0],
      events: undefined, // keep it undefined
    };

    window.onscroll = () => {
      return false;
    };

    this.moveEvent = this.moveEvent.bind(this);
  }

  getTimeInMinutes = (date) => {
    return date.getHours() * 60 + date.getMinutes();
  };

  isSlotNotAvailable = (pickedTime) => {
    const clinicCloseTime = this.getTimeInMinutes(this.state.max);
    const clientPickedTime = this.getTimeInMinutes(pickedTime);
    const clientPickedDay = moment(pickedTime).day();
    const notAvailableEvents = this.state.events.filter(
      (event) =>
        event.appointmentType === EVENT_TYPES.breakTime &&
        moment(event.start).day() === clientPickedDay,
    );

    return (
      clientPickedTime >= clinicCloseTime ||
      notAvailableEvents.some((event) => {
        const providerNotAvailableStart = this.getTimeInMinutes(event.start);
        const providerNotAvailableEnd = this.getTimeInMinutes(event.end);

        return (
          clientPickedTime >= providerNotAvailableStart &&
          clientPickedTime < providerNotAvailableEnd
        );
      })
    );
  };

  handleSelect = ({ start }) => {
    if (this.isSlotNotAvailable(start)) {
      return;
    }

    let time = moment(start);
    if (time.isAfter(this.getNow())) {
      this.props.history.push(
        `/appointment/create/${this.state.provider_id}/${
          this.state.clinic_id
        }/${apiDateFormat(start)}/${time.format("HH:mm:ss")}`,
      );
    }
  };

  getNow = () => {
    return new Date(
      new Date().getTime() +
        (momentTimezone.tz(new Date(), this.state.clinic_timezone)._offset +
          new Date().getTimezoneOffset()) *
          60000,
    );
  };

  timeRangeFormat = ({ start, end }, culture, localizer) => {
    let s = localizer.format(start, this.state.timeFormat, culture);
    let e = localizer.format(end, this.state.timeFormat, culture);
    return `${s} - ${e}`;
  };

  moveEvent({ event, start, end, resourceId, isAllDay: droppedOnAllDaySlot }) {
    if (event.availabilityGrid) {
      return false;
    }
    if (event.appointmentType === EVENT_TYPES.breakTime) {
      return false;
    }
    if (!checkIfPermissionAllowed("update-cancel-reschedule-appointment")) {
      return false;
    }
    if (event.checkedIn) {
      return false;
    }
    if (event.resourceId !== resourceId) {
      return;
    }
    if (event.isAdditionalProvider) {
      uiNotification.error(
        "Appointment can only be rescheduled from the main provider's calendar",
      );
      return;
    }
    if (
      event.appointmentType === EVENT_TYPES.outOfOffice &&
      !moment(start).isSame(event.start, "day")
    ) {
      return;
    }
    let outOfOfficeOverlapCheck = false;
    if (event.appointmentType === EVENT_TYPES.outOfOffice) {
      if (this.state.events && this.state.events.length) {
        this.state.events.map((obj) => {
          let format = "hh:mm:ss";
          let dropTime = moment(start, format);
          let beforeTime = moment(obj.start, format);
          let afterTime = moment(obj.end, format);
          if (
            (dropTime.isBetween(beforeTime, afterTime) &&
              moment(start).isSame(moment(obj.end))) ||
            moment(start).isSame(moment(obj.start))
          ) {
            outOfOfficeOverlapCheck = true;
          }
        });
      }
    }

    if (outOfOfficeOverlapCheck) {
      uiNotification.error("Provider is already booked at this time!");
      return false;
    }

    let allDay = event.allDay;

    if (!event.allDay && droppedOnAllDaySlot) {
      allDay = true;
    } else if (event.allDay && !droppedOnAllDaySlot) {
      allDay = false;
    }

    var isAfterOriginalEventDate =
      moment(event.start).isAfter(new Date()) ||
      moment(event.start).isSame(new Date(), "day");
    var isAfter =
      moment(start).isAfter(new Date()) ||
      moment(start).isSame(new Date(), "day");
    let currentDate = moment(new Date());
    let eventOriginalDate = moment(event.start);
    var currentDayCheck = eventOriginalDate.diff(currentDate, "days");
    if (isAfterOriginalEventDate && isAfter && currentDayCheck >= 0) {
      const updatedEvent = { ...event, start, end, resourceId, allDay };

      let formData = {};
      formData.startdate = moment(start).format("YYYY-MM-DD HH:mm:ss");
      localStorage.setItem("rescheduledTime", formData.startdate);
      formData.appointment_id = event.id;
      this.setState({
        updatedEvent: updatedEvent,
        appointment_id: event.id,
        rescheduleFormData: formData,
        showRescheduleConfirmModal: true,
      });
    }
  }

  handleReschedule = (formData) => {
    this.setState({
      showLoader: true,
    });

    this.props
      .rescheduleAppointment(formData)
      .then((data) => {
        let returnState = {};
        const rescheduleData = data.data || {};

        returnState.appointment_email_text =
          rescheduleData.appointment_email_text;
        returnState.notification_body = rescheduleData.appointment_email_text;
        returnState.appointment_sms = rescheduleData.appointment_sms;
        returnState.appointment_subject = rescheduleData.appointment_subject;
        returnState.patient_name = rescheduleData.patient_name;
        returnState.success_msg = rescheduleData.success_msg;
        returnState.showAppointmentDetails = false;
        returnState.showNotifyPop = Boolean(rescheduleData.send_email_status);
        returnState.showLoader = false;

        if (!returnState.showNotifyPop) {
          this.refreshAppointments();
          uiNotification.success("Appointment rescheduled successfully");
        }

        this.setState(returnState);
      })
      .catch((res) => {
        uiNotification.error(
          tSales(`checkoutInvoice.apiError.${res.message}`, {
            defaultValue: tSales("checkoutInvoice.apiError.fallback"),
          }),
        );
      })
      .finally(() => {
        this.setState({
          showLoader: false,
        });
      });
  };

  rescheduleAppoint = () => {
    localStorage.setItem("showLoader", true);

    this.setState({
      showLoader: true,
      showRescheduleConfirmModal: false,
    });

    let formData = this.state.rescheduleFormData;

    this.props.checkRescheduleTime(formData).then((data) => {
      const rescheduleData = data.data || {};
      let returnState = {};

      if (rescheduleData.status === "fail") {
        returnState.showLoader = false;
        if (
          this.state.updatedEvent.appointmentType === EVENT_TYPES.outOfOffice
        ) {
          uiNotification.error("Provider is already booked at this time!");
        } else {
          let pushURL = `/appointment/edit/${this.state.updatedEvent.id}/reschedule`;
          if (this.state.clinic_id) {
            pushURL += `/${this.state.clinic_id}`;
          }
          this.props.history.push(pushURL);
        }

        return this.setState(returnState);
      } else {
        if (
          this.state.updatedEvent.appointmentType === EVENT_TYPES.outOfOffice
        ) {
          let time = moment(this.state.updatedEvent.start, "h:mm A").format(
            "HH:mm",
          );
          let timeArr = time.split(":");
          time = timeArr[0] + ":00:00";

          let pushURL = `/appointment/edit/${this.state.updatedEvent.id}/reschedule/${time}`;
          if (this.state.clinic_id) {
            pushURL += `/${this.state.clinic_id}`;
          }
          this.props.history.push(pushURL);
        } else {
          if (rescheduleData.fee_details?.cancellation_fee > 0) {
            returnState.cancellation_fee =
              rescheduleData.fee_details.cancellation_fee;
            returnState.showLoader = false;
            returnState.showAppointmentDetails = false;
            returnState.showModal = true;

            return this.setState(returnState);
          } else {
            returnState.showLoader = true;
            let formData = {};
            formData.appointment_id = this.state.updatedEvent.id;
            formData.appointment_date = moment(
              this.state.updatedEvent.start,
            ).format("YYYY-MM-DD");
            formData.appointment_time = moment(
              this.state.updatedEvent.start,
            ).format("HH:mm:ss");
            this.handleReschedule(formData);

            return this.setState(returnState);
          }
        }
      }
    });
  };

  componentWillUnmount() {
    document.body.style.overflow = "";
    uiNotification.clear();
  }

  componentDidMount() {
    const languageData = JSON.parse(localStorage.getItem("languageData")) || {};
    let startEndDateWeek = "";
    let formData = {};
    formData.start = this.props.match.params.date
      ? moment(this.props.match.params.date).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    formData.end = this.props.match.params.date
      ? moment(this.props.match.params.date).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    let returnState = {};
    returnState.showLoader = true;
    returnState.showModal = false;

    if (this.props.match.params.appointmentId) {
      returnState.dontShowAppointment = true;
      returnState.editAppointmentId = this.props.match.params.appointmentId;
      returnState.showAppointmentDetails = true;
      if (window.location.search.includes("provider_id")) {
        const queryParams = queryString.parse(window.location.search);
        returnState.provider_id = queryParams.provider_id;
        formData.provider_id = queryParams.provider_id;
      }
      this.getAppointments(formData);
      this.setState(returnState);
    } else if (
      this.props.match.params.providerId &&
      this.props.match.params.clinicId &&
      this.props.match.params.view
    ) {
      returnState.clinic_id = this.props.match.params.clinicId;
      returnState.showLoader = true;
      returnState.provider_id = this.props.match.params.providerId;
      returnState.calendarView = this.props.match.params.view;
      formData.clinic_id = this.props.match.params.clinicId;
      formData.provider_id = this.props.match.params.providerId;
      returnState.searchPickerDate = moment(
        this.props.match.params.date,
      ).toDate();
      formData.searchPickerDate = apiDateFormat(this.props.match.params.date);
      returnState.selectedDate = moment(this.props.match.params.date).toDate();
      this.setState(returnState, () => {
        let calendarFilter = JSON.stringify(formData);
        localStorage.setItem("calendarFilter", calendarFilter);
        this.getAppointments(formData);
      });
    } else if (localStorage.getItem("calendarFilter")) {
      let calendarFilter = JSON.parse(localStorage.getItem("calendarFilter"));
      let date = this.props.match.params.date
        ? moment(this.props.match.params.date).toDate()
        : moment(calendarFilter.searchPickerDate).toDate();
      returnState.searchPickerDate = this.props.match.params.date
        ? moment(this.props.match.params.date).toDate()
        : moment(calendarFilter.searchPickerDate).toDate();
      if (calendarFilter.calendarView === Views.WEEK) {
        returnState.calendarView = Views.WEEK;
        returnState.showSelectedDate = showSelectedWeek(date);
        startEndDateWeek = startEndDateOfWeek(date, "YYYY-MM-DD");
        formData.start = apiDateFormat(startEndDateWeek.start);
        formData.end = apiDateFormat(startEndDateWeek.end);
      } else if (calendarFilter.calendarView === Views.DAY) {
        returnState.showSelectedDate = viewDateFormat(date);
        formData.start = formData.end = apiDateFormat(calendarFilter.start);
      } else {
        returnState.calendarView = "verticals";
        returnState.showSelectedDate = viewDateFormat(date);
        formData.start = formData.end = apiDateFormat(calendarFilter.start);
      }
      formData.provider_id = calendarFilter.provider_id;
      formData.clinic_id = calendarFilter.clinic_id;
      returnState.provider_id = calendarFilter.provider_id;
      this.setState(returnState, () => {
        this.getAppointments(formData, calendarFilter.calendarView);
      });
    } else {
      this.setState(returnState);
      this.getAppointments(formData);
    }
    if (!this.state.verticalsEnabled) {
      this.setState({
        calendarView: Views.DAY,
      });
    }
    let windowHeight = parseInt(window.innerHeight);
    let calendarHeight = windowHeight - 267;
    document.getElementById("juvly-section").style.height =
      calendarHeight + "px";
    this.setState({
      appointment_calendar: languageData.appointments["appointment_calendar"],
      appointment_services: languageData.appointments["appointment_services"],
      appointment_services_packages:
        languageData.appointments["appointment_services_packages"],
      appointment_provider_schedule:
        languageData.appointments["appointment_provider_schedule"],
      appointment_equipment_schedule:
        languageData.appointments["appointment_equipment_schedule"],
      appointment_resource_schedule:
        languageData.appointments["appointment_resource_schedule"],
      appointment_booking_history:
        languageData.appointments["appointment_booking_history"],
      appointment_reports: languageData.appointments["appointment_reports"],
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let returnState = {};

    if (nextProps.showLoader != undefined && nextProps.showLoader == false) {
      returnState.showLoader = false;
      return returnState;
    }

    if (
      nextProps.notificationSent != undefined &&
      nextProps.notificationSent == true &&
      nextProps.notiTimeStamp != prevState.notiTimeStamp
    ) {
      if (localStorage.getItem("showLoader") == "false") {
        returnState.showLoader = false;
        returnState.showNotifyPop = false;
        returnState.notificationSent = nextProps.notificationSent;
        returnState.notiTimeStamp = nextProps.notiTimeStamp;
        return returnState;
      }
    }

    if (
      nextProps.appointmentsData != undefined &&
      nextProps.appointmentsData !== prevState.appointmentsData &&
      nextProps.appointmentsTimestamp != prevState.appointmentsTimestamp
    ) {
      if (localStorage.getItem("showLoader") == "false") {
        let resourceMap = [],
          appointments = [];
        if (
          nextProps.appointmentsData.providers.length &&
          !isViewDetailsApptModal()
        ) {
          returnState.provider_id = nextProps.appointmentsData.provider_id;
        }
        if (prevState.dontShowAppointment) {
          returnState.dontShowAppointment = false;
        }

        if (
          nextProps.appointmentsData.availability &&
          nextProps.appointmentsData.availability == "not_available"
        ) {
          returnState.disableCalendar = true;
        } else {
          returnState.disableCalendar = false;
        }
        if (nextProps.appointmentsData.appointments.length) {
          nextProps.appointmentsData.appointments.map((obj) => {
            let dateArr = obj.appointment_date.split("-");
            let startTime = obj.appointment_start_time.split(":");
            let endTime = obj.appointment_end_time.split(":");
            let title = makeTitle(obj);
            let nameWithTitle = "";
            let apptColor = "";
            let gradient = "";
            let confirmed_status = "";

            if (obj.type === EVENT_TYPES.appointment) {
              nameWithTitle = displayName(obj.patient) + " (" + title + ")";
              title = "(" + title + ")";
              apptColor = obj?.additional_provider
                ? obj.color + "B3"
                : obj.color;
            } else if (obj.type === EVENT_TYPES.outOfOffice) {
              if (obj.appointment_booking) {
                nameWithTitle =
                  "(" +
                  obj.appointment_booking.appointment_notes +
                  " - Out of office)";
              } else {
                nameWithTitle = "(Out of office)";
              }
              title = "(Out of office)";
              apptColor = "#000000";
            } else {
              title = "(Not Available)";
              nameWithTitle = "(Not Available)";
              apptColor = "#9c9c9c";
              gradient =
                "repeating-linear-gradient(to bottom, #cccccc 0px, #cccccc 69px, #9c9c9c 69px, #9c9c9c 70px)";
            }
            if (
              obj.type === EVENT_TYPES.appointment &&
              obj.appointment_datetime > moment().format("YYYY-MM-DD HH:mm:ss")
            ) {
              confirmed_status =
                Number(obj.is_confirmed) === 0 ? "Not Confirmed" : "Confirmed";
            }
            const isAdditionalProvider = isAdditionalProviderAppointment(obj);
            appointments.push({
              id: obj.id ? obj.id : Math.floor(Math.random() * 1000),
              title: title,
              duration: obj.duration,
              start: new Date(
                dateArr[0],
                dateArr[1] - 1,
                dateArr[2],
                startTime[0],
                startTime[1],
                startTime[2],
              ),
              end: new Date(
                dateArr[0],
                dateArr[1] - 1,
                dateArr[2],
                endTime[0],
                endTime[1],
                endTime[2],
              ),
              resourceId: obj.appointment_vertical
                ? obj.appointment_vertical.id
                : parseInt(obj.user_id),
              color: apptColor,
              gradient: gradient,
              clientName: obj.patient ? displayName(obj.patient) : "",
              clientEmail:
                obj.patient && obj.patient.email ? obj.patient.email : "",
              confirmed_status: confirmed_status,
              appointments_checkin:
                obj.type === EVENT_TYPES.appointment &&
                obj.appointment_type === "in_person"
                  ? Number(obj.patient_checkedin) === 1
                    ? "Checked In"
                    : "Not Checked In"
                  : "",
              clientPhone:
                obj.appointment_booking && obj.appointment_booking.phone
                  ? obj.appointment_booking.phone.replace(/[- )(]/g, "")
                  : "",
              clientNameWithTitle: nameWithTitle,
              checkedIn: obj.patient_checkedin ? obj.patient_checkedin : 0,
              appointmentType: obj.type,
              isReschedule: !!obj.is_reschedule,
              isAdditionalProvider,
              additionalProvider: obj.additional_provider,
              isConsentCompleted: isAdditionalProvider
                ? undefined
                : obj.is_consent_completed,
              isQuestionnaireCompleted: isAdditionalProvider
                ? undefined
                : obj.is_questionnaire_completed,
              gfeColor: obj.gfe_icon_color,
            });
            if (
              obj.appointment_vertical &&
              resourceMap.findIndex(
                (r) => r.resourceId === obj.appointment_vertical.id,
              ) === -1
            ) {
              resourceMap.push({
                resourceId: obj.appointment_vertical.id,
                resourceTitle: obj.appointment_vertical.name,
                isVertical: true,
              });
            }
          });
        }

        if (prevState.calendarView === "verticals") {
          returnState.verticalsList = nextProps.appointmentsData.verticals;
          returnState.clinic_timezone =
            nextProps.appointmentsData.clinic_timezone;

          if (!resourceMap.length) {
            if (nextProps.appointmentsData.resources.length) {
              nextProps.appointmentsData.resources.map((obj) => {
                resourceMap.push({
                  resourceId: obj.id,
                  resourceTitle: displayName(obj),
                  resourceColor: "#FF1493",
                  workingHours: obj.working_hours,
                });
              });
            } else {
              resourceMap.push({
                resourceId: 0,
                resourceTitle: "",
                resourceColor: "#FF1493",
              });
            }
          } else {
            resourceMap.unshift({
              resourceId: "total",
              resourceTitle: nextProps.appointmentsData.clinics.find(
                (c) =>
                  Number(c.id) === Number(nextProps.appointmentsData.clinic_id),
              ).clinic_name,
              isVertical: true,
              workingHours:
                nextProps.appointmentsData?.resources[0]?.working_hours,
            });
            _cloneDeep(appointments).map((e) => {
              e.resourceId = "total";
              appointments.push(e);
              return e;
            });
          }
        } else {
          if (nextProps.appointmentsData.resources.length) {
            nextProps.appointmentsData.resources.map((obj) => {
              resourceMap.push({
                resourceId: obj.id,
                resourceTitle: displayName(obj),
                resourceColor: "#FF1493",
                workingHours: obj.working_hours,
              });
            });
          } else {
            resourceMap.push({
              resourceId: 0,
              resourceTitle: "",
              resourceColor: "#FF1493",
            });
          }
        }

        let clinic = nextProps.appointmentsData.clinics.find(
          (y) => Number(y.id) === Number(nextProps.appointmentsData.clinic_id),
        );
        let open = nextProps.appointmentsData.clinicOpensAt.split(":");
        let close = nextProps.appointmentsData.clinicClosesAt.split(":");
        returnState.events = prevState.forceChanged
          ? prevState.events
          : appointments;
        returnState.clinics = nextProps.appointmentsData.clinics;
        returnState.providers = nextProps.appointmentsData.providers;
        returnState.tmpProviders = nextProps.appointmentsData.providers;
        returnState.appointmentsTimestamp = nextProps.appointmentsTimestamp;
        returnState.clinic_timezone =
          nextProps.appointmentsData.clinic_timezone;
        if (nextProps.appointmentsData.providers.length === 0) {
          for (let x in prevState) {
            if (x.startsWith("provider-")) {
              returnState[x] = false;
            }
          }
        }

        if (returnState.provider_id) {
          let provider = returnState.providers.find(
            (e) => Number(e.id) === Number(returnState.provider_id),
          );
          returnState.providerName = displayName(provider);
        }

        returnState.resourceMap = resourceMap;
        returnState.clinic_id = nextProps.appointmentsData.clinic_id;
        returnState.selectedClinic = clinic ? clinic.clinic_name : "";
        returnState.showLoader = false;
        returnState.forceChanged = false;
        returnState.min = new Date(2019, 1, 28, open[0], open[1], open[2]);
        returnState.max = new Date(2019, 1, 28, close[0], close[1], close[2]);
      }
      return returnState;
    }

    return null;
  }

  handleInputChange = (event) => {
    const target = event.target;
    let value = target.value;
    let name = event.target.name;
    let returnState = {};
    switch (target.type) {
      case "radio": {
        value = target.value;
        break;
      }
    }
    if (name === "provider_id") {
      returnState.clinic_id = "";
    }

    if (name === "notification_type" && value) {
      returnState.notification_body =
        value === "sms"
          ? this.state.appointment_sms
          : this.state.appointment_email_text;
    }

    if (name === "searchProvider") {
      let result = this.state.providers.filter((word) => {
        let name = displayName(word).toLowerCase();
        return name.indexOf(value.trim().toLowerCase()) > -1;
      });
      this.setState({ tmpProviders: result });
    }
    returnState[event.target.name] = value;

    if (
      !name.startsWith("notes-") &&
      name != "notification_body" &&
      name != "notification_type" &&
      name != "notes" &&
      !name.startsWith("provider-") &&
      !name.startsWith("searchProvider")
    ) {
      localStorage.setItem("showLoader", true);
      returnState.showLoader = true;
      let startEndDateWeek;
      if (this.state.calendarView === Views.WEEK) {
        startEndDateWeek = startEndDateOfWeek(
          this.state.selectedDate,
          "YYYY-MM-DD",
        );
      } else if (this.state.calendarView === Views.DAY) {
        startEndDateWeek = {
          start: this.state.selectedDate,
          end: this.state.selectedDate,
        };
      } else {
        startEndDateWeek = {
          start: this.state.selectedDate,
          end: this.state.selectedDate,
        };
      }
      this.setState(returnState, () => {
        this.refreshAppointments(
          startEndDateWeek.start,
          startEndDateWeek.end,
          this.state.calendarView,
        );
      });
    } else {
      this.setState(returnState);
    }
  };

  handleNextPrevDate = (navigate) => {
    var selectedDate = moment(this.state.selectedDate);
    let calendarView = this.state.calendarView;
    let returnState = {};
    switch (calendarView) {
      case Views.WEEK:
        if (navigate === "next") {
          let newSelectedDate = selectedDate.add(1, "weeks").toDate();
          returnState.selectedDate = newSelectedDate;
          returnState.showSelectedDate = showSelectedWeek(newSelectedDate);
          returnState.searchPickerDate = moment(returnState.selectedDate)
            .startOf("week")
            .toDate();
          returnState.isChangeWeek = true;
        } else if (navigate === "prev") {
          let newSelectedDate = selectedDate.subtract(1, "weeks").toDate();
          returnState.selectedDate = newSelectedDate;
          returnState.showSelectedDate = showSelectedWeek(newSelectedDate);
          returnState.searchPickerDate = moment(returnState.selectedDate)
            .startOf("week")
            .toDate();
          returnState.isChangeWeek = true;
        } else {
          returnState.selectedDate = moment();
          selectedDate = moment();
          returnState.showSelectedDate = showSelectedWeek(selectedDate);
          returnState.searchPickerDate = moment(
            returnState.selectedDate,
          ).toDate();
          returnState.isChangeWeek = false;
        }
        break;
      case Views.DAY:
        if (navigate === "next") {
          let newSelectedDate = selectedDate.add(1, "days").toDate();
          returnState.selectedDate = newSelectedDate;
          returnState.showSelectedDate = viewDateFormat(
            moment(newSelectedDate),
          );
        } else if (navigate === "prev") {
          let newSelectedDate = selectedDate.subtract(1, "days").toDate();
          returnState.selectedDate = newSelectedDate;
          returnState.showSelectedDate = viewDateFormat(
            moment(newSelectedDate),
          );
        } else {
          selectedDate = moment();
          returnState.selectedDate = moment().toDate();
          returnState.showSelectedDate = viewDateFormat(moment());
        }
        returnState.searchPickerDate = moment(
          returnState.selectedDate,
        ).toDate();
        break;
      case "verticals":
        if (navigate === "next") {
          let newSelectedDate = selectedDate.add(1, "days").toDate();
          returnState.selectedDate = newSelectedDate;
          returnState.showSelectedDate = viewDateFormat(
            moment(newSelectedDate),
          );
        } else if (navigate === "prev") {
          let newSelectedDate = selectedDate.subtract(1, "days").toDate();
          returnState.selectedDate = newSelectedDate;
          returnState.showSelectedDate = viewDateFormat(
            moment(newSelectedDate),
          );
        } else {
          selectedDate = moment();
          returnState.selectedDate = moment().toDate();
          returnState.showSelectedDate = viewDateFormat(moment());
        }
        returnState.searchPickerDate = moment(
          returnState.selectedDate,
        ).toDate();
        break;
    }
    localStorage.setItem("showLoader", true);
    let formattedDate = selectedDate;
    formattedDate = formattedDate.format("YYYY-MM-DD");
    returnState.showLoader = true;

    let startEndDateWeek;
    if (calendarView === Views.WEEK) {
      startEndDateWeek = startEndDateOfWeek(selectedDate, "YYYY-MM-DD");
    } else {
      startEndDateWeek = { start: formattedDate, end: formattedDate };
    }
    this.setState(returnState, () => {
      this.refreshAppointments(
        startEndDateWeek.start,
        startEndDateWeek.end,
        this.state.calendarView,
      );
    });
  };

  getAppointments = (formData, view = "") => {
    const viewType = view || this.state.calendarView || Views.DAY;
    this.setState({
      showLoader: true,
    });
    return this.props
      .getAppointments(
        formData,
        viewType === "verticals" && this.state.verticalsEnabled,
      )
      .finally(() => {
        this.setState({
          showLoader: false,
        });
      });
  };

  showEvent = (event) => {
    if (event.appointmentType === EVENT_TYPES.breakTime) {
      return false;
    }
    this.setState({
      editAppointmentId: event.id,
      showAppointmentDetails: true,
    });
  };

  closePopUp = () => {
    this.setState({
      showAppointmentDetails: false,
    });
    if (isViewDetailsApptModal()) {
      const nextSearchQueries = queryString.parse(window.location.search);
      delete nextSearchQueries.view_details;
      if (window.location.search.includes("provider_id")) {
        delete nextSearchQueries.provider_id;
      }
      history.push(
        window.location.pathname +
          `?${queryString.stringify(nextSearchQueries)}`,
      );
    }
  };

  refreshAppointments = (start, end, view = "") => {
    let formData = {};
    if (view == "") {
      view = this.state.calendarView;
    }
    let startEndDateWeek;
    if (view === Views.WEEK) {
      startEndDateWeek = startEndDateOfWeek(
        this.state.selectedDate,
        "YYYY-MM-DD",
      );
    } else {
      startEndDateWeek = {
        start: this.state.selectedDate,
        end: this.state.selectedDate,
      };
    }
    formData.start = start
      ? apiDateFormat(start)
      : apiDateFormat(startEndDateWeek.start);
    formData.end = end
      ? apiDateFormat(end)
      : apiDateFormat(startEndDateWeek.end);
    formData.provider_id = this.state.provider_id;

    if (this.state.clinic_id) {
      formData.clinic_id = this.state.clinic_id;
    }

    let calendarFilter = JSON.parse(JSON.stringify(formData));

    calendarFilter.searchPickerDate = this.state.selectedDate;
    calendarFilter.calendarView = view;
    localStorage.setItem("calendarFilter", JSON.stringify(calendarFilter));
    this.setState({
      showLoader: true,
    });
    return this.getAppointments(formData, view);
  };

  changeClinic = (event) => {
    localStorage.setItem("showLoader", true);
    let clinicId = parseInt(event.currentTarget.dataset.id);
    let formData = {},
      returnState = {},
      clinic = {};

    let dateToSend = this.getFormDataDate();
    formData.start = apiDateFormat(dateToSend.start);
    formData.end = apiDateFormat(dateToSend.end);
    formData.provider_id = this.state.provider_id;
    formData.clinic_id = clinicId;
    if (clinicId) {
      clinic = this.state.clinics.find((y) => Number(y.id) === clinicId);
      returnState.selectedClinic = clinic.clinic_name;
    } else {
      returnState.clinic_id = clinicId;
      returnState.selectedClinic = "Please Select";
    }
    formData.searchPickerDate = apiDateFormat(this.state.selectedDate);
    returnState.showLoader = true;
    returnState.provider_id = this.state.provider_id;
    this.setState(returnState, () => {
      let calendarFilter = JSON.stringify(formData);
      localStorage.setItem("calendarFilter", calendarFilter);
      this.getAppointments(formData);
    });
  };

  handleCalendarView = (nextCalendarView) => {
    localStorage.setItem("showLoader", true);
    let returnState = {};
    returnState.calendarView = nextCalendarView;
    returnState.selectedDate = this.state.selectedDate;

    if (nextCalendarView === Views.WEEK) {
      returnState.showSelectedDate = showSelectedWeek(returnState.selectedDate);
    } else if (nextCalendarView === Views.DAY) {
      returnState.isChangeWeek = false;
      if (this.state.returnState) {
        returnState.selectedDate = moment(returnState.selectedDate)
          .startOf("week")
          .toDate();
      }
      returnState.showSelectedDate = viewDateFormat(returnState.selectedDate);
    } else {
      returnState.isChangeWeek = false;
      if (this.state.returnState) {
        returnState.selectedDate = moment(returnState.selectedDate)
          .startOf("week")
          .toDate();
      }
      returnState.showSelectedDate = viewDateFormat(returnState.selectedDate);
    }

    returnState.searchPickerDate = moment(returnState.selectedDate).toDate();
    returnState.showLoader = true;
    let formattedDate = moment(returnState.selectedDate);
    formattedDate = formattedDate.format("YYYY-MM-DD");
    let startEndDateWeek;

    if (nextCalendarView === Views.WEEK) {
      startEndDateWeek = startEndDateOfWeek(
        this.state.selectedDate,
        "YYYY-MM-DD",
      );
    } else if (nextCalendarView === Views.DAY) {
      startEndDateWeek = { start: formattedDate, end: formattedDate };
    } else {
      startEndDateWeek = { start: formattedDate, end: formattedDate };
    }

    const pathMatch = matchPath(window.location.pathname, {
      path: APPOINTMENT_ROUTES.calendarProviderViewDate({
        providerId: ":providerId",
        clinicId: ":clinicId",
        view: ":view",
        date: ":date?",
      }),
      exact: true,
      strict: false,
    });

    if (pathMatch?.params) {
      const newUrl = APPOINTMENT_ROUTES.calendarProviderViewDate({
        providerId: pathMatch.params.providerId,
        clinicId: pathMatch.params.clinicId,
        view: nextCalendarView,
        date: pathMatch.params.date || "",
      });

      window.history.replaceState(null, "", newUrl);
    }

    this.setState(returnState, () => {
      this.refreshAppointments(
        startEndDateWeek.start,
        startEndDateWeek.end,
        nextCalendarView,
      );
    });
  };

  getFormDataDate = () => {
    let selDate = moment(this.state.selectedDate);
    selDate = selDate.format("YYYY-MM-DD");
    let startEndDateWeek;
    if (this.state.calendarView === Views.WEEK) {
      startEndDateWeek = startEndDateOfWeek(
        this.state.selectedDate,
        "YYYY-MM-DD",
      );
    } else if (this.state.calendarView === Views.DAY) {
      startEndDateWeek = { start: selDate, end: selDate };
    } else {
      startEndDateWeek = { start: selDate, end: selDate };
    }
    return startEndDateWeek;
  };

  handleSearchDatePicker = (date) => {
    localStorage.setItem("showLoader", true);
    let returnState = {};
    returnState.showLoader = true;
    returnState.searchPickerDate = date;
    returnState.isChangeWeek = false;
    returnState.selectedDate = date;
    if (this.state.calendarView === Views.WEEK) {
      returnState.showSelectedDate = showSelectedWeek(returnState.selectedDate);
    } else if (this.state.calendarView === Views.DAY) {
      returnState.isChangeWeek = false;
      if (this.state.returnState) {
        returnState.selectedDate = moment(returnState.selectedDate)
          .startOf("week")
          .toDate();
      }
      returnState.showSelectedDate = viewDateFormat(returnState.selectedDate);
    } else {
      returnState.isChangeWeek = false;
      if (this.state.returnState) {
        returnState.selectedDate = moment(returnState.selectedDate)
          .startOf("week")
          .toDate();
      }
      returnState.showSelectedDate = viewDateFormat(returnState.selectedDate);
    }
    returnState.calendarView = this.state.calendarView;
    let formattedDate = moment(date);
    formattedDate = formattedDate.format("YYYY-MM-DD");
    let startEndDateWeek;
    if (this.state.calendarView === Views.WEEK) {
      startEndDateWeek = startEndDateOfWeek(date, "YYYY-MM-DD");
    } else if (this.state.calendarView === Views.DAY) {
      startEndDateWeek = { start: formattedDate, end: formattedDate };
    } else {
      startEndDateWeek = { start: formattedDate, end: formattedDate };
    }
    this.setState(returnState, () => {
      this.refreshAppointments(startEndDateWeek.start, startEndDateWeek.end);
    });
  };

  componentDidUpdate = (prevProps) => {
    if (
      this.state.showModal ||
      this.state.showPrintModal ||
      this.state.showRescheduleConfirmModal ||
      this.state.showAppointmentDetails ||
      this.state.showNotifyPop
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    ReactTooltip.rebuild();

    if (
      (!prevProps.appointmentDataStatus ||
        prevProps.appointmentDataStatus === "pending") &&
      this.props.appointmentDataStatus === "loading"
    ) {
      this.setState({ showLoader: true });
    }

    if (
      prevProps.appointmentDataStatus === "success" &&
      this.props.appointmentDataStatus === "loading"
    ) {
      this.setState({ showLoader: true });
    }
  };

  sendNotification = () => {
    if (!this.state.notification_body.trim()) {
      return false;
    }
    let formData = {};
    localStorage.setItem("showLoader", true);
    this.setState({ showLoader: true });

    formData.appointment_id = this.state.appointment_id;
    formData.action = "rescheduled";
    formData.notification_type = this.state.notification_type;
    formData.notification_body = this.state.notification_body;
    formData.notification_subject = this.state.appointment_subject;
    formData.sms_body = this.state.appointment_sms;

    this.props.sendNotification(formData).then(() => {
      this.refreshAppointments();
    });
  };

  dismissModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  dismissRescheduleModal = () => {
    this.setState({
      showRescheduleConfirmModal: !this.state.showRescheduleConfirmModal,
    });
  };

  dismissPrintModal = () => {
    this.setState({
      showPrintModal: !this.state.showPrintModal,
    });
  };

  printAppt = (data) => {
    this.props
      .printAppointment(data)
      .then((res) => {
        if (res.data?.file) {
          window.open(res.data.file);
        }
      })
      .catch(() => {
        uiNotification.error("Unable to print. Try again later.");
      })
      .finally(() => {
        this.setState({ showPrintModal: false, showLoader: false });
      });
  };

  print = (mode) => {
    if (localStorage.getItem("calendarFilter")) {
      localStorage.setItem("showLoader", true);
      this.setState({ showLoader: true });
      let calendarFilter = JSON.parse(localStorage.getItem("calendarFilter"));
      calendarFilter.print_type = mode;
      if (!calendarFilter.clinic_id) {
        calendarFilter.clinic_id = this.state.clinic_id;
      }
      this.printAppt(calendarFilter);
    } else {
      let formData = {};
      formData.print_type = mode;
      formData.start = moment().format("YYYY-MM-DD");
      formData.end = moment().format("YYYY-MM-DD");
      formData.clinic_id = this.state.clinic_id;
      this.printAppt(formData);
    }
  };

  closeNotiPop = () => {
    uiNotification.success(this.state.globalLang[this.state.success_msg]);

    this.setState({
      showNotifyPop: !this.state.showNotifyPop,
    });
    this.refreshAppointments();
  };

  chargeAndReschedule = (event) => {
    let charge = event.currentTarget.dataset.charge;
    let formData = {};
    formData.appointment_id = this.state.updatedEvent.id;
    formData.patient_to_be_charged = charge == "true" ? 1 : 0;
    formData.appointment_date = moment(this.state.updatedEvent.start).format(
      "YYYY-MM-DD",
    );
    formData.appointment_time = moment(this.state.updatedEvent.start).format(
      "HH:mm:ss",
    );
    localStorage.setItem("showLoader", true);
    this.setState({ showModal: false, showLoader: true });
    this.handleReschedule(formData);
  };

  setTodayDate = () => {
    let returnState = {};
    returnState.searchPickerDate = moment(new Date()).toDate();
    returnState.selectedDate = moment(new Date()).toDate();

    if (this.state.calendarView === Views.WEEK) {
      returnState.showSelectedDate = showSelectedWeek(
        returnState.searchPickerDate,
      );
    } else if (this.state.calendarView === Views.DAY) {
      returnState.showSelectedDate = viewDateFormat(
        returnState.searchPickerDate,
      );
    } else {
      returnState.showSelectedDate = viewDateFormat(
        returnState.searchPickerDate,
      );
    }
    this.setState(returnState, () => {
      this.handleCalendarView(this.state.calendarView);
    });
  };

  closeOutPopUp = () => {
    this.setState({ showOutOfOfficeData: false });
  };

  dismissDeleteModal = () => {
    this.setState({ showDeleteModal: false });
  };

  handleEditorChange = (childState) => {
    this.setState(childState);
  };

  tConvert = (time) => {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      time = time.slice(1);
      if (this.state.timeFormat === "hh:mm A") {
        time[5] = +time[0] < 12 ? "AM" : "PM";
        time[0] = +time[0] % 12 || 12;
      }
    }
    delete time[3];

    if (time[0] < 10) {
      time[0] = "0" + Number(time[0]);
    }
    return time.join("");
  };

  render() {
    var stringLengt = this.state.selectedClinic;
    const smartBookingUrl = this.props?.currentBookingUrls?.bookingUrl;
    let pName = this.state.patient_name ? this.state.patient_name : "";

    let finalText = "";

    if (
      (this.state.calendarView === Views.DAY ||
        this.state.calendarView === "verticals") &&
      this.state.resourceMap &&
      this.state.resourceMap[0].workingHours &&
      this.state.resourceMap[0].workingHours[0] &&
      this.state.resourceMap[0].workingHours[0].schedule &&
      this.state.resourceMap[0].workingHours[0].schedule.length > 0
    ) {
      this.state.resourceMap[0].workingHours[0].schedule.map((obj) => {
        finalText +=
          "<br> Starts " +
          this.tConvert(obj.from_time) +
          "&nbsp; Ends " +
          this.tConvert(obj.to_time);
      });
    }

    const preparedEvents = prepareEvents(this.state.events);

    return (
      <div id="content">
        <div className="container-fluid content">
          <div className="juvly-section full-width m-b-0">
            <div className="calender-title">
              {/* Header START */}

              <div className={classes.header}>
                <div className={classes.left}>
                  <span className={classes.name}>Calendar</span>
                  <a
                    onClick={this.setTodayDate}
                    className="new-line-btn no-width m-l-0"
                  >
                    Today
                  </a>
                  <div className="cal-arrow-outer m-0">
                    <a
                      className="cal-arrow pull-left"
                      onClick={this.handleNextPrevDate.bind(this, "prev")}
                    >
                      <img alt="" src="/images/cal-arrow-left.png" />
                    </a>
                    <a
                      className="cal-arrow pull-right"
                      onClick={this.handleNextPrevDate.bind(this, "next")}
                    >
                      <img alt="" src="/images/cal-arrow-right.png" />
                    </a>
                  </div>
                  <div>
                    {this.state.calendarView === Views.DAY && (
                      <div className="calName p-0">
                        {moment(this.state.searchPickerDate).format(
                          "MMMM Do, YYYY",
                        )}
                      </div>
                    )}
                    {this.state.calendarView === Views.WEEK && (
                      <div className="calName p-0">
                        {this.state.showSelectedDate}
                      </div>
                    )}
                    {this.state.calendarView === "verticals" && (
                      <div className="calName p-0">
                        {moment(this.state.searchPickerDate).format(
                          "MMMM Do, YYYY",
                        )}
                      </div>
                    )}
                  </div>
                  <CalendarStepSelect
                    value={this.state.calendarStep}
                    onChange={(o) => this.setState({ calendarStep: o })}
                  />
                </div>
                <div className={classes.center}>
                  <div className="calName">
                    {this.state.providerName
                      ? this.state.providerName + "'s Calendar"
                      : ""}{" "}
                    {(this.state.calendarView === Views.DAY ||
                      this.state.calendarView === "verticals") &&
                    this.state.resourceMap &&
                    this.state.resourceMap[0].workingHours &&
                    this.state.resourceMap[0].workingHours[0] &&
                    this.state.resourceMap[0].workingHours[0].schedule &&
                    this.state.resourceMap[0].workingHours[0].schedule
                      .length ? (
                      <div
                        className="singleProviderDuration"
                        dangerouslySetInnerHTML={{ __html: finalText }}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className={classes.right}>
                  <div className="calClinicdropDown">
                    <div className="dropdown pull-left weekDropdowncal">
                      <button
                        className="btn btn-default calClinicFilter dropdown-toggle"
                        type="button"
                        data-toggle="dropdown"
                        data-tip={stringLengt}
                      >
                        {stringLengt.length > 16
                          ? stringLengt.substring(0, 16) + "..."
                          : stringLengt}
                        <i className="fas fa-angle-down"></i>
                      </button>
                      <ul className="cal-dropdown clinicname-dropdown dropdown-menu">
                        <Scrollbars
                          autoHeight
                          autoHeightMin={0}
                          autoHeightMax={306}
                          className="full-width"
                          renderTrackHorizontal={(props) => (
                            <div
                              {...props}
                              style={{ display: "none" }}
                              className="track-horizontal"
                            />
                          )}
                        >
                          {this.state.clinics.length > 0 &&
                            this.state.clinics.map((obj, idx) => {
                              return (
                                <li
                                  key={"clinics-" + idx}
                                  data-id={obj.id}
                                  onClick={this.changeClinic}
                                >
                                  <a>
                                    <label>{obj.clinic_name}</label>
                                  </a>
                                </li>
                              );
                            })}
                        </Scrollbars>
                      </ul>
                    </div>
                  </div>
                  <div className="calWeekdropDown">
                    <div className="dropdown">
                      <button
                        className="btn btn-default dropdown-toggle"
                        type="button"
                        data-toggle="dropdown"
                        id="weekDayDropdown"
                      >
                        {capitalizeFirstLetter(this.state.calendarView)}
                        <i className="fas fa-angle-down"></i>
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="weekDayDropdown"
                      >
                        {this.state.verticalsEnabled && (
                          <li>
                            <a
                              onClick={() =>
                                this.handleCalendarView("verticals")
                              }
                              name="expoType"
                            >
                              Verticals
                            </a>
                          </li>
                        )}
                        <li>
                          <a
                            onClick={() => this.handleCalendarView(Views.WEEK)}
                            name="expType"
                          >
                            Week
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => this.handleCalendarView(Views.DAY)}
                            name="expoType"
                          >
                            Day
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <Link
                    to={`/appointment/providers/calendar/${moment(
                      this.state.searchPickerDate,
                    ).format("YYYY-MM-DD")}/${this.state.clinic_id}`}
                    className="new-line-btn m-l-0 p-r-10 p-l-10 no-width"
                  >
                    Clinic View
                  </Link>
                  <AppointmentHeader
                    smartBookingUrl={smartBookingUrl}
                    togglePrint={this.dismissPrintModal}
                  />
                </div>
              </div>

              {/* Header END */}
            </div>
            <div
              className={
                this.state.calendarView === "verticals" &&
                this.state.events &&
                this.state.events.length
                  ? "CalendarOuter clearfix"
                  : "CalendarOuter clearfix"
              }
            >
              <div className="calendarLeftSection">
                {checkIfPermissionAllowed("create-appointment") && (
                  <Link
                    id="create_appointment1"
                    className="new-blue-btn CreateAppointmentBtn"
                    data-url="/appointments/add_appointment"
                    to={"/appointment/create/" + this.state.provider_id}
                  >
                    {"Create"}
                  </Link>
                )}
                <div className="leftCalendar">
                  <DatePicker
                    value={
                      this.state.searchPickerDate
                        ? viewDateFormat(this.state.searchPickerDate)
                        : null
                    }
                    onChange={this.handleSearchDatePicker}
                    className="setting-search-input search-key"
                    dateFormat="YYYY-MM-dd"
                    minDate={new Date(moment().subtract(10, "years"))}
                    selected={this.state.searchPickerDate}
                    openToDate={this.state.searchPickerDate}
                    name="searchPickerDate"
                    autoComplete="off"
                    inline
                  />
                  {!!this.state.verticalsList?.length &&
                    this.state.calendarView === "verticals" && (
                      <div className="sidebarSectionContainer">
                        <h3 className="sidebarHeading">Verticals</h3>
                        <Scrollbars
                          autoHeight
                          autoHeightMin={0}
                          autoHeightMax={188}
                          className="full-width"
                          renderTrackHorizontal={(props) => (
                            <div
                              {...props}
                              style={{ display: "none" }}
                              className="track-horizontal"
                            />
                          )}
                        >
                          <ul>
                            {this.state.verticalsList.map((vertical) => {
                              return (
                                <li
                                  className="verticalsLegendItem"
                                  key={vertical.id}
                                >
                                  <div
                                    style={{ backgroundColor: vertical.color }}
                                    className="verticalsLegendIndicator"
                                  />
                                  <div className="sidebarItemName">
                                    {vertical.name}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </Scrollbars>
                      </div>
                    )}
                  <div className="sidebarSectionContainer">
                    <h3 className="sidebarHeading">Filter providers</h3>
                    <input
                      type="text"
                      className="searchProvider"
                      name="searchProvider"
                      placeholder="Search Provider"
                      onChange={this.handleInputChange}
                      value={this.state.searchProvider}
                    />
                    <Scrollbars
                      autoHeight
                      autoHeightMin={0}
                      autoHeightMax={192}
                      className="full-width"
                      renderTrackHorizontal={(props) => (
                        <div
                          {...props}
                          style={{ display: "none" }}
                          className="track-horizontal"
                        />
                      )}
                    >
                      <ul
                        className={
                          this.state.calendarView === "verticals"
                            ? "cal-dropdown"
                            : "cal-dropdown cal-service-dropdown"
                        }
                      >
                        {this.state.tmpProviders.length > 0 &&
                          this.state.tmpProviders.map((obj, idx) => {
                            let colorObj = {
                              borderColor: obj.appointment_color,
                            };
                            if (this.state.calendarView === "verticals") {
                              colorObj.borderColor = "#dcdcdc";
                              colorObj.backgroundColor = "#fff";
                            } else if (
                              Number(this.state["provider_id"]) ===
                              Number(obj.id)
                            ) {
                              colorObj.backgroundColor = obj.appointment_color;
                            } else {
                              colorObj.backgroundColor = "#fff";
                            }
                            return (
                              <li key={"provider-" + idx}>
                                <a>
                                  <label className="checkbox">
                                    <input
                                      style={colorObj}
                                      type="checkbox"
                                      value={obj.id}
                                      name={"provider_id"}
                                      onChange={this.handleInputChange}
                                      checked={
                                        Number(this.state["provider_id"]) ===
                                        Number(obj.id)
                                          ? "checked"
                                          : false
                                      }
                                    />{" "}
                                    {displayName(obj)}
                                  </label>
                                </a>
                              </li>
                            );
                          })}
                      </ul>
                    </Scrollbars>
                  </div>
                </div>
              </div>
              <div className="calendarrightSection calendarrightSectionWithSidebar">
                <div
                  className={
                    this.state.calendarView === Views.WEEK
                      ? "juvly-section full-width m-t-0 week-view-calendar calendarScrollContainer"
                      : "juvly-section full-width m-t-0 day-view-calendar calendarScrollContainer"
                  }
                  id="juvly-section"
                >
                  <div
                    className={
                      this.state.calendarView !== Views.WEEK &&
                      this.state.disableCalendar
                        ? "disableCalender"
                        : "no-display"
                    }
                  >
                    <p>
                      No schedule defined for {this.state.providerName} for
                      selected date.
                    </p>
                  </div>
                  {this.state.events && (
                    <CalendarWrapper>
                      <DragAndDropCalendar
                        selectable
                        formats={{
                          timeGutterFormat: this.state.timeFormat,
                          eventTimeRangeFormat: this.timeRangeFormat,
                          selectRangeFormat: this.timeRangeFormat,
                        }}
                        localizer={localizer}
                        views={[Views.WEEK, Views.DAY]}
                        events={preparedEvents}
                        min={this.state.min}
                        max={this.state.max}
                        resources={this.state.resourceMap}
                        resourceIdAccessor="resourceId"
                        resourceTitleAccessor="resourceTitle"
                        onEventDrop={this.moveEvent}
                        view={
                          this.state.calendarView === Views.WEEK
                            ? Views.WEEK
                            : Views.DAY
                        }
                        defaultDate={new Date(2019, 0, 29)}
                        onSelectSlot={this.handleSelect}
                        onSelectEvent={this.showEvent}
                        step={this.state.calendarStep.value}
                        timeslots={this.state.calendarStep.slots}
                        showMultiDayTimes
                        toolbar={false}
                        date={this.state.selectedDate}
                        getNow={() => this.getNow()}
                        components={{
                          event: CalendarEvent,
                          eventWrapper: EventWrapper,
                        }}
                      />
                    </CalendarWrapper>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.showAppointmentDetails && (
          <ModalAppointmentDetails
            id={Number(this.state.editAppointmentId)}
            onClose={this.closePopUp}
            refetchAppointments={this.refreshAppointments}
            onFetchSuccess={(appt) => {
              if (isViewDetailsApptModal()) {
                const date = moment.utc(appt.date).toDate();
                this.setState(
                  {
                    provider_id: appt.provider.id,
                    providerName: appt.provider.name,
                    selectedDate: date,
                    showSelectedDate: viewDateFormat(appt.date),
                    searchPickerDate: date,
                    clinic_id: appt.clinic.id,
                  },
                  () => {
                    this.refreshAppointments();
                  },
                );
              }
            }}
          />
        )}
        {this.state.showNotifyPop && (
          <ModalRescheduleNotification
            onClose={this.closeNotiPop}
            patientName={pName}
            handleInputChange={this.handleInputChange}
            notificationType={this.state.notification_type}
            notificationBody={this.state.notification_body}
            handleEditorChange={this.handleEditorChange}
            sendNotification={this.sendNotification}
          />
        )}
        {this.state.showModal && (
          <ModalRescheduleFee
            fee={this.state.cancellation_fee}
            onClose={this.dismissModal}
            onReschedule={this.chargeAndReschedule}
          />
        )}
        {this.state.showPrintModal && (
          <ModalPrint
            onPrint={(type) => this.print(type)}
            onClose={() =>
              this.setState({
                showPrintModal: false,
              })
            }
          />
        )}
        {this.state.showRescheduleConfirmModal && (
          <ModalRescheduleConfirm
            onClose={this.dismissRescheduleModal}
            onConfirm={this.rescheduleAppoint}
          />
        )}
        {(this.state.showLoader || this.state.events === undefined) && (
          <PageOverlayLoader
            message={
              this.state.appointmentLang.appointment_processing_please_wait
            }
          />
        )}
        <ReactTooltip effect="float" multiline={true} place="left" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  let returnState = {};

  const languageData = JSON.parse(localStorage.getItem("languageData")) || {
    global: {},
  };

  returnState.appointmentDataStatus =
    state.AppointmentReducer?.appointmentDataStatus;

  localStorage.setItem("showLoader", false);

  if (state.AppointmentReducer?.action === "GET_APPOINTMENTS") {
    if (state.AppointmentReducer.data?.status === 200) {
      returnState.appointmentsData = state.AppointmentReducer?.data?.data;
      returnState.appointmentsTimestamp = new Date();
    } else {
      uiNotification.error(
        languageData.global[state.AppointmentReducer.data?.message],
      );
      returnState.showLoader = false;
    }
  }

  if (state.AppointmentReducer?.action === "SEND_NOTIFICATION_CALENDAR") {
    if (state.AppointmentReducer.data?.status === 200) {
      returnState.notificationSent = true;
      returnState.notiTimeStamp = new Date();
    } else {
      returnState.showLoader = false;
    }
  }

  return returnState;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAppointments,
      checkRescheduleTime,
      rescheduleAppointment,
      sendNotification,
      printAppointment,
    },
    dispatch,
  );
}

export default pipe(
  NewCalendar,
  connect(mapStateToProps, mapDispatchToProps),
  withGetBookingUrlsQuery,
  DragDropContext(HTML5Backend),
);
